document.addEventListener("DOMContentLoaded", () => {

    //Navigation controls
    const mainNav = document.getElementById('main-nav');
    const mobileNav = document.getElementById('mobile-nav');
    const mainNavClose = document.getElementById('main-nav__close');
    const mainNavToggler = document.getElementById('main-nav__toggler');
    const localeSwitcher = document.getElementById('localeSwitcher');

    const setMobileMenuOpen = (isOpen) => {
        if (!mainNav || !mobileNav || !mainNavToggler || !mainNavClose) return;

        mobileNav.classList.toggle('show', isOpen);
        mobileNav.setAttribute('aria-hidden', String(!isOpen));
        mainNav.classList.toggle('nav-open', isOpen);
        mainNavToggler.classList.toggle('d-none', isOpen);
        mainNavToggler.setAttribute('aria-expanded', String(isOpen));
        mainNavClose.classList.toggle('d-none', !isOpen);
        mainNavClose.setAttribute('aria-expanded', String(isOpen));
        if (localeSwitcher) localeSwitcher.classList.toggle('d-none', isOpen);
    };

    if (mainNavToggler && mainNavClose) {
        mainNavToggler.addEventListener('click', () => setMobileMenuOpen(true));
        mainNavClose.addEventListener('click', () => setMobileMenuOpen(false));
        document.querySelectorAll('.navbar-mobile-nav .element-menu').forEach((navElement) => {
            navElement.addEventListener('click', () => setMobileMenuOpen(false));
        });
    }

    //FAQ operations
    document.querySelectorAll('.open-faq').forEach((faqTitle) => {
        faqTitle.addEventListener("click", () => {
            let answerElem = document.getElementById(faqTitle.dataset.dropdownId);
            if (!answerElem) return;
            answerElem.classList.toggle('show');
            if (answerElem.classList.contains('show')) {
                gsap.to(answerElem, {
                    height: "auto",
                    duration: 0.2
                });
            } else {
                gsap.to(answerElem, {
                    height: 0,
                    duration: 0.2
                })
            }
        });
    });

    document.querySelectorAll('.flash-messages .alert').forEach((flashMessage) => {
        setTimeout(() => {
            flashMessage.classList.add('d-none');
        }, "5000");
    });

    //Cookie notification
    const closeCookies = document.getElementById('CloseCookiesNotice');
    if (closeCookies !== null) {
        closeCookies.addEventListener("click", () => {
            document.getElementById('CookieWarning').style.display = 'none';
        });
    }

    const localeMenuToggle = document.getElementById('localeMenuToggle');
    if (localeMenuToggle !== null) {
        localeMenuToggle.addEventListener("click", () => {
            const localeMenu = document.getElementById('localeMenu');
            if (!localeMenu) return;

            const isOpen = localeMenu.classList.toggle('show');
            localeMenuToggle.setAttribute('aria-expanded', String(isOpen));
        });
    }


    //Deal with any hero animations
    document.querySelectorAll('.hero-element').forEach((heroElem) => {
        ScrollTrigger.create({
            trigger: heroElem,
            onEnter: () => {
                setTimeout(function () {
                    heroElem.classList.add('plane-animation');
                }, 1000);
            }
        });
    });

    //Scrolling class on the main nav
    if (mainNav && document.querySelector('div.layout')) {
        ScrollTrigger.create({
            trigger: "div.layout",
            start: "top top-=150px",
            onToggle: self => {
                mainNav.classList.toggle('scrolling', self.isActive);
            }
        });
    }


});
